import { useQuery, useQueryClient } from "@tanstack/react-query";
import Drawer from "../../../../drawer/Drawer";
import { useEffect } from "react";

const ManageArtistDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const queryClient = useQueryClient();

  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl6"}
      size={"xl6"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          Artist {data?._id ? "update" : "create"}
        </span>
      }
      subtitle="View order details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-auto scrollbar flex bg-gradient-to-tr from-[#f5faff] via-white to-[#fef6f9]"
    ></Drawer>
  );
};

export default ManageArtistDrawer;
